import "./MacroIndex.css";

function Bar({ className }: { className: string }) {
  return <div className={`bastion-skeleton ${className}`} />;
}

function CardSkeleton() {
  return (
    <div className="macro-loading-card">
      <div className="macro-loading-card__header">
        <div>
          <Bar className="macro-loading-card__title" />
          <Bar className="macro-loading-card__subtitle" />
        </div>
        <Bar className="macro-loading-card__icon" />
      </div>
      <Bar className="macro-loading-card__value" />
      <Bar className="macro-loading-card__period" />
      <Bar className="macro-loading-card__desc" />
      <Bar className="macro-loading-card__desc" />
      <Bar className="macro-loading-card__desc macro-loading-card__desc--short" />
      <div className="macro-loading-card__footer">
        <Bar className="macro-loading-card__source" />
        <Bar className="macro-loading-card__open" />
      </div>
    </div>
  );
}

export function MacroIndexSkeleton() {
  return (
    <div className="macro-page">
      <main className="macro-main">
        <header className="macro-hero">
          <Bar className="macro-loading-kicker" />
          <Bar className="macro-loading-title" />
          <Bar className="macro-loading-copy" />
          <Bar className="macro-loading-copy macro-loading-copy--short" />
        </header>

        <section className="macro-section">
          <Bar className="macro-loading-section-title" />
          <div className="macro-card-grid">
            <CardSkeleton />
            <CardSkeleton />
          </div>
        </section>

        <section className="macro-section">
          <Bar className="macro-loading-section-title" />
          <div className="macro-card-grid">
            <CardSkeleton />
            <CardSkeleton />
          </div>
        </section>
      </main>
    </div>
  );
}

export function MacroChartSkeleton() {
  return (
    <div className="macro-page">
      <main className="macro-main">
        <Bar className="macro-loading-back" />
        <header className="macro-loading-detail-hero">
          <Bar className="macro-loading-kicker" />
          <Bar className="macro-loading-title" />
          <Bar className="macro-loading-copy macro-loading-copy--short" />
        </header>
        <div className="macro-loading-chart">
          <div className="macro-loading-chart__toolbar">
            <Bar className="macro-loading-chart__code" />
            <div className="macro-loading-chart__ranges">
              <Bar className="macro-loading-chip" />
              <Bar className="macro-loading-chip" />
              <Bar className="macro-loading-chip" />
              <Bar className="macro-loading-chip" />
            </div>
          </div>
          <Bar className="macro-loading-chart__canvas" />
        </div>
      </main>
    </div>
  );
}